// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"545":"58e9af22","574":"4086c0a6","644":"cb88f74b","822":"3fd67d88"}[chunkId] + ".chunk.css";
};